"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=2063%3A722))
 * @lastsynced 2023-08-15T21:03:21.707Z
 */
export const Pin = createSVGIcon(
  <>
    <path
      d="M19.4286 8.71429C19.4286 12.9829 11.7143 23.2857 11.7143 23.2857C11.7143 23.2857 4 12.9829 4 8.71429C4 6.66833 4.81275 4.70617 6.25946 3.25946C7.70617 1.81275 9.66833 1 11.7143 1C13.7602 1 15.7224 1.81275 17.1691 3.25946C18.6158 4.70617 19.4286 6.66833 19.4286 8.71429V8.71429Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7143 11.2857C13.1344 11.2857 14.2857 10.1344 14.2857 8.71425C14.2857 7.29409 13.1344 6.14282 11.7143 6.14282C10.2941 6.14282 9.14282 7.29409 9.14282 8.71425C9.14282 10.1344 10.2941 11.2857 11.7143 11.2857Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Pin",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
